module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Dirty Version")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780062231437_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "repi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Epigraph#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIGRAPH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "rint"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062231437_Introduction#int"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(": "), _c('i', [_vm._v("No Father to His Style")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICKEY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_1#ch1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_1#ch1"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("U")]), _vm._v("-T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANG")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AB")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUNKEN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HETTO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UPERSTAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UPPERIZED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LD")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELFARE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEESE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME ON")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRU")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SCAPE TO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLINGBORO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTORATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN IN THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ED")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TART")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARING")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULLETPROOF")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGA")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEASE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOLE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N A")]), _vm._v(" G B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILDING")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKIN")]), _vm._v("’ A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPES OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDICINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REE TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTY")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELL")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IM")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/9780062231437_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAMBER")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMBER")]), _vm._v(" 9, V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSE")]), _vm._v(" 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rfin"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Final_Thoughts#fin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOUGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Acknowledgements#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rnot"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rbib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Biblography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rphoto"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Photo_Section#photo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Authors#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rcre"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Credits#cre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rcopy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062231437_Copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ratp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHER")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-389b8618","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062231437_Contents.vue
// module id = 72
// module chunks = 0